export default __webpack_public_path__ + "static/media/check.1e15a835.svg";